<template>
  <div class="flex flex-col gap-2" :class="{ 'mt-2': !hideResetButton }">
    <button
      v-if="selectedId && !hideResetButton"
      type="button"
      class="self-start text-xs leading-5 text-gray-500 hover:text-gray-700 border-b border-dashed border-gray-300"
      @click="resetFilter"
    >
      Сбросить
    </button>

    <div class="flex flex-col gap-1">
      <CatalogFilterMuscTreeNode
        v-for="item in items"
        :key="item.id"
        :node="item"
        :level="0"
        :selected-id="selectedId"
        :expanded-map="expandedMap"
        @select="handleSelect"
        @toggle="handleToggle"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  items: { type: Array, default: () => [] },
  modelValue: { type: Object, default: null },
  tree: { type: [Array, Object], default: null },
  hideResetButton: { type: Boolean, default: false },
});
const emit = defineEmits(["update:modelValue"]);

const expandedMap = ref({});

const selectedId = computed(() => {
  if (!props.modelValue || typeof props.modelValue !== "object") return null;

  for (const [id, isSelected] of Object.entries(props.modelValue)) {
    if (isSelected) return id;
  }

  return null;
});

const findPathToNode = (nodes, targetId, path = []) => {
  if (!Array.isArray(nodes) || !targetId) return null;

  for (const node of nodes) {
    const currentPath = [...path, node.id];
    if (node.id === targetId) return currentPath;

    if (Array.isArray(node.items) && node.items.length > 0) {
      const childPath = findPathToNode(node.items, targetId, currentPath);
      if (childPath) return childPath;
    }
  }

  return null;
};

const findNodeById = (nodes, targetId) => {
  if (!Array.isArray(nodes) || !targetId) return null;

  for (const node of nodes) {
    if (node.id === targetId) return node;

    if (Array.isArray(node.items) && node.items.length > 0) {
      const found = findNodeById(node.items, targetId);
      if (found) return found;
    }
  }

  return null;
};

const handleSelect = (node) => {
  if (!node?.id) return;

  emit("update:modelValue", { [node.id]: true });

  if (Array.isArray(node.items) && node.items.length > 0) {
    expandedMap.value[node.id] = true;
  }
};

const handleToggle = (nodeId) => {
  if (!nodeId) return;
  expandedMap.value[nodeId] = !expandedMap.value[nodeId];
};

const resetFilter = () => {
  emit("update:modelValue", {});
};

watch(
  () => selectedId.value,
  (id) => {
    if (!id) return;

    const path = findPathToNode(props.items, id);
    if (!path || path.length === 0) return;

    for (const pathId of path.slice(0, -1)) {
      expandedMap.value[pathId] = true;
    }
    const selectedNode = findNodeById(props.items, id);
    if (Array.isArray(selectedNode?.items) && selectedNode.items.length > 0) {
      expandedMap.value[id] = true;
    }
  },
  { immediate: true }
);
</script>
